<template>
    <el-amap :vid="amapVue" :zoom="zoom" :center="center" class="amap-demo">
        <el-amap-marker :position="center"></el-amap-marker>
    </el-amap>
</template>

<script>
export default {
    data() {
        return {
            amapVue: "",
            zoom: 17,
            center: [106.670925, 26.558997]
        }
    },
    methods: {

    },
    created() {

    }
}
</script>

<style scoped lang="scss">
.amap-demo {
    height: 100%;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/assembly/amap.vue